import { Box, Button, Container, Stack, Typography, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import { slide as Menu } from 'react-burger-menu';
import { useNavigate } from 'react-router-dom';
import MuiLink from '@mui/material/Link';
import logo from '../../images/logos.png';

export default function Nav() {
  const matches = useMediaQuery('(min-width:900px)');
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const Link = (props) => <MuiLink onClick={() => setIsOpen(false)} {...props} />;

  return (
    <Box sx={{ backgroundColor: '#f0f1f6' }} className="nav">
      <Container maxWidth="lg" sx={{ position: 'relative' }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Link href="/" sx={{ width: { xs: 156, md: 190 } }}>
            <img src={logo} alt="" width="100%" style={{ maxHeight: 72 }} />
          </Link>
          {matches ? (
            <>
              <Stack direction="row" alignItems="center" spacing={2} sx={{ p: 2, pr: 0 }}>
                <Link href="/">
                  <Typography variant="h6">Home</Typography>
                </Link>
                <Link href="/#about">
                  <Typography variant="h6">About Us</Typography>
                </Link>
                <Link href="/#services">
                  <Typography variant="h6">Services</Typography>
                </Link>
                <Link href="/products">
                  <Typography variant="h6">Market Place</Typography>
                </Link>
                <Link href={`${process.env.PUBLIC_URL}/shopifytoapp.html`}>
                  <Typography variant="h6">Shopify Apps</Typography>
                </Link>
                <Link href="/#testimonials">
                  <Typography variant="h6">Testimonials</Typography>
                </Link>
                <Link href="/#faq">
                  <Typography variant="h6">FAQ</Typography>
                </Link>
              </Stack>
              <Button
                variant="contained"
                color="primary"
                disableElevation
                size="large"
                sx={{ color: 'white' }}
                onClick={() => navigate('/login')}
              >
                Login
              </Button>
            </>
          ) : (
            <div id="ham-nav">
              <Menu right width={360} isOpen={isOpen} onOpen={() => setIsOpen(true)} onClose={() => setIsOpen(false)}>
                <Link href="/">
                  <Typography variant="h6">Home</Typography>
                </Link>
                <Link href="/#about">
                  <Typography variant="h6">About Us</Typography>
                </Link>
                <Link href="/#services">
                  <Typography variant="h6">Services</Typography>
                </Link>
                <Link href="/products">
                  <Typography variant="h6">Market Place</Typography>
                </Link>
                <Link href={`${process.env.PUBLIC_URL}/shopifytoapp.html`}>
                  <Typography variant="h6">Shopify Apps</Typography>
                </Link>
                <Link href="/#testimonials">
                  <Typography variant="h6">Testimonials</Typography>
                </Link>
                <Link href="/#faq">
                  <Typography variant="h6">FAQ</Typography>
                </Link>
                <Button
                  variant="contained"
                  color="primary"
                  disableElevation
                  sx={{ color: 'white' }}
                  onClick={() => navigate('/login')}
                >
                  Login
                </Button>
              </Menu>
            </div>
          )}
        </Stack>
      </Container>
    </Box>
  );
}
